module.exports = __webpack_public_path__ + "assets/img/report-title.886f142e.png";